import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import { LoadingModalStyled, LoadingModalText } from '../../styledComponents';
import Icon from '../ui/icon';
import loadingIndicator from '../../images/loading_indicator.svg';

interface IProps {
	isOpen: boolean;
	disableTransparency?: boolean;
	loadingText?: string;
}

function LoadingModal(props: IProps) {
	const { isOpen, disableTransparency, loadingText } = props;
	const { t } = useTranslation();

	return (
		<Modal isOpen={isOpen} disableTransparency={!!disableTransparency}>
			<LoadingModalStyled disableTransparency={!!disableTransparency}>
				<Icon img={loadingIndicator} rotating />
				<LoadingModalText>{loadingText || t('loading')}</LoadingModalText>
			</LoadingModalStyled>
		</Modal>
	);
}

export default LoadingModal;
